module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-load-store.c7a1c624.png";